import { render, staticRenderFns } from "./FinishedBuildPage.vue?vue&type=template&id=21972401"
import script from "./FinishedBuildPage.vue?vue&type=script&lang=js"
export * from "./FinishedBuildPage.vue?vue&type=script&lang=js"
import style0 from "./FinishedBuildPage.vue?vue&type=style&index=0&id=21972401&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports